export default "__VITE_ASSET__CfaXi6xj__"